import { firebaseAction } from 'vuexfire'
import { dbThemesRef } from '../../firebaseConfig'

const state = {
  themes: [],
  theme: {
    id: null,
    name: null,
    description: null,
    options: {}
  }
}

const getters = {
  getThemes: state => state.themes,
  theme: state => state.theme
}

const mutations = {
  updateTheme (state, { name, description, price, options }) {
    state.theme.name = name,
    state.theme.description = description,
    state.theme.price = price,
    state.theme.options = options
  }
}

const actions = {
  setThemesRef: firebaseAction(({ bindFirebaseRef }, { ref }) => {
    bindFirebaseRef('themes', ref)
  }),
  commitThemeUpdates (context, theme) {
    context.commit('updateTheme', {
      name: theme.name,
      description: theme.description,
      price: theme.price,
      options: theme.options
    })
  },
  refreshThemeById (context, { themeId }) {
   dbThemesRef.child(themeId).on('value', (snap) => {
      context.dispatch('commitThemeUpdates', snap.val())
      // console.log(snap.val())
    })
     // context.dispatch('commitThemeUpdates', response.data)
    // context.dispatch('commitThemeUpdates', response.data)
    //
    // ref.child('-KjVxBYyKv3_PFLavId3')

    // try {
    //   const response = dbThemesRef.child(themeId)
    //   if (response.length > 1) {
    //     context.dispatch('commitThemeUpdates',  response.data )
    //   }
    //   else {
    //     throw(response)
    //   }
    // }
    // catch(error) {
    //   throw(error)
    // }

  }
}


export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/themes.js